import React, { Component } from "react";
import { showOnlyActiveEnt, getFilter } from "../actions";
import ReactTooltip from "react-tooltip";
import LocationHint from "./LocationHint";
const { connect } = require("react-redux");

class SharingContainer extends Component {
  render() {
    // console.log(this.props.data)
    const {
      getFilter,
      showOnlyActEnt,
      showOnlyActiveEnt,
      choosenElements,
      legend,
    } = this.props;

    const lists = this.props.data
      .filter((ent, index) => {
        return showOnlyActEnt[this.props.name] ? ent.active : ent;
      })
      .map((ent, index) => {
        return (
          <li className="list-group-item clearfix" key={ent.value}>
            {ent.value}
            <span
              className={
                ent.active ? "antall activeElem" : "antall noactiveElem"
              }
            >
              {" "}
              ({ent.count})
            </span>
            <span className="pull-right">
              <input
                id={this.props.prefix + "__" + (ent.id ? ent.id : ent.value)}
                className="inputsmall"
                checked={ent.checked}
                onChange={(e) =>
                  getFilter(
                    this.props.name,
                    this.props.prefix + "__" + (ent.id ? ent.id : ent.value),
                    e,
                    ent.id ? ent.id : ent.value,
                    choosenElements
                  )
                }
                type="checkbox"
              />
            </span>
          </li>
        );
      });

    return (
      <div>
        <ReactTooltip />
        <div className="wellstyle">
          {this.props.title}
          <span className="pull-right">
            {this.props.title === "Location" ? (
              <LocationHint legend={legend} />
            ) : null}
            <input
              id={`showhidesharingid` + this.props.name}
              data-tip="Show / hide empty"
              checked={showOnlyActEnt[this.props.name]}
              type="checkbox"
              onChange={(e) => showOnlyActiveEnt(this.props.name)}
            />
          </span>
        </div>
        {/* <SearchInput fuzzy={true} throttle={800} className="search-input" onChange={this.searchUpdated.bind(this)} />*/}
        <ul className="list-group navstyle">{lists}</ul>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showOnlyActEnt: state.showOnlyActEnt,
    choosenElements: state.choosenElements,
    legend: state.legend,
  };
}

const mapDispatchToProps = {
  showOnlyActiveEnt,
  getFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(SharingContainer);



// WEBPACK FOOTER //
// ./src/components/SharingContainer.js